import { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const MemberIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-6 h-6"
      width={width}
      height={height}
      viewBox="-4 -4 40 40"
    >
      <circle data-color="color-2" fill={color} cx="6" cy="6" r="3" />{' '}
      <path
        data-color="color-2"
        fill={color}
        d="M7,25V15c0-1.479,0.464-2.85,1.25-3.982C8.167,11.013,8.084,11,8,11H4c-2.206,0-4,1.794-4,4 v6h2v7h7v-3H7z"
      />{' '}
      <circle data-color="color-2" fill={color} cx="26" cy="6" r="3" />{' '}
      <path
        data-color="color-2"
        fill={color}
        d="M25,25V15c0-1.479-0.464-2.85-1.25-3.982C23.833,11.013,23.916,11,24,11h4 c2.206,0,4,1.794,4,4v6h-2v7h-7v-3H25z"
      />{' '}
      <path
        fill={color}
        d="M18,10h-4c-2.757,0-5,2.243-5,5v8h3v8h8v-8h3v-8C23,12.243,20.757,10,18,10z"
      />{' '}
      <circle fill={color} cx="16" cy="4" r="4" />
    </svg>
  );
};
